import React from 'react';
import { storage } from '../../../../services/StorageService';
import { buttonStyle, sectionHeaderStyle } from './styles';

interface CharacterAdminProps {
  onAction: (action: string, data?: any) => void;
}

export const CharacterAdmin: React.FC<CharacterAdminProps> = ({ onAction }) => {
  return (
    <>
      <div style={sectionHeaderStyle}>Character</div>
      <button style={buttonStyle} onClick={() => onAction('change_char')}>🔄 Change Character</button>
      <button style={buttonStyle} onClick={() => onAction('toggle_dev_login')}>🎮 Dev Login: {storage.get('helix_force_login') ? 'OFF' : 'ON'}</button>
    </>
  );
};
